// extracted by mini-css-extract-plugin
module.exports = {"timer":"Timer_timer__dt39z","timerLight":"Timer_timerLight__1vptD"};